export const CONTRACT_TYPE = {
  FREELANCE: 'FREELANCE',
  EMPLOYEE: 'EMPLOYEE',
} as const;
